import { gql } from '@apollo/client';
import { DiscountInfo } from '../fragments';

export default gql`
  query discounts {
    discounts {
      ...DiscountInfo
    }
  }
  ${DiscountInfo}
`;
